var _defs, _g, _g2, _g3, _path, _path2, _path3, _path4, _path5, _path6, _g4, _g5, _path7, _path8, _path9, _g6, _path10, _g7, _g8, _g9, _g10, _polygon, _path11, _path12, _g11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLittleBasket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128.06pt",
    height: "176.25pt",
    viewBox: "0 0 128.06 176.25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "glyph-21-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.25 0v-0.57812h-1.1719v-0.48438l1.2344-1.8125h0.46875v1.8125h0.35938v0.48438h-0.35938v0.57812zm0-1.0625v-0.96875l-0.65625 0.96875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-21-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.0938-2.875c0.28125 0 0.5 0.10156 0.65625 0.29688 0.1875 0.23047 0.28125 0.62109 0.28125 1.1719 0 0.54297-0.09375 0.92969-0.28125 1.1562-0.15625 0.19922-0.375 0.29688-0.65625 0.29688-0.27344 0-0.49609-0.10156-0.67188-0.3125-0.16797-0.21875-0.25-0.60156-0.25-1.1562 0-0.53906 0.09375-0.92578 0.28125-1.1562 0.15625-0.19531 0.36719-0.29688 0.64062-0.29688zm0 0.45312c-0.0625 0-0.12109 0.023437-0.17188 0.0625-0.054687 0.042969-0.09375 0.12109-0.125 0.23438-0.03125 0.13672-0.046875 0.375-0.046875 0.71875 0 0.33594 0.015625 0.5625 0.046875 0.6875s0.070313 0.21094 0.125 0.25c0.050781 0.042969 0.10938 0.0625 0.17188 0.0625 0.070312 0 0.13281-0.019531 0.1875-0.0625 0.050781-0.039062 0.085938-0.11719 0.10938-0.23438 0.039063-0.13281 0.0625-0.36719 0.0625-0.70312 0-0.34375-0.015625-0.57812-0.046875-0.70312s-0.074219-0.20703-0.125-0.25c-0.054688-0.039063-0.11719-0.0625-0.1875-0.0625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-21-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.03125 0 0.73438-1.0625-0.70312-1.0156h0.65625l0.375 0.57812 0.39062-0.57812h0.64062l-0.70312 0.98438 0.76562 1.0938h-0.67188l-0.42188-0.64062-0.42188 0.64062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-21-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.15625-0.76562 0.53125-0.0625c0.007812 0.13672 0.050781 0.24219 0.125 0.3125 0.082031 0.074219 0.17578 0.10938 0.28125 0.10938 0.11328 0 0.20703-0.039062 0.28125-0.125 0.070312-0.09375 0.10938-0.21094 0.10938-0.35938 0-0.13281-0.039063-0.23828-0.10938-0.3125-0.074219-0.082031-0.16406-0.125-0.26562-0.125-0.074219 0-0.15625 0.011719-0.25 0.03125l0.0625-0.4375c0.14453 0 0.25391-0.03125 0.32812-0.09375 0.082031-0.070313 0.125-0.16406 0.125-0.28125 0-0.09375-0.03125-0.16406-0.09375-0.21875-0.054688-0.0625-0.125-0.09375-0.21875-0.09375s-0.17969 0.03125-0.25 0.09375c-0.0625 0.0625-0.10156 0.15625-0.10938 0.28125l-0.51562-0.078125c0.039062-0.17578 0.09375-0.31641 0.15625-0.42188 0.070312-0.10156 0.17188-0.17969 0.29688-0.23438 0.13281-0.0625 0.28125-0.09375 0.4375-0.09375 0.26953 0 0.48438 0.085938 0.64062 0.25 0.13281 0.14844 0.20312 0.30859 0.20312 0.48438 0 0.25-0.13672 0.44922-0.40625 0.59375 0.16406 0.042969 0.29688 0.125 0.39062 0.25 0.09375 0.11719 0.14062 0.26172 0.14062 0.4375 0 0.25-0.09375 0.46484-0.28125 0.64062-0.17969 0.17969-0.40234 0.26562-0.67188 0.26562-0.26172 0-0.48047-0.070312-0.65625-0.21875-0.16797-0.15625-0.26172-0.35156-0.28125-0.59375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-21-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.0938-1.4688-0.53125 0.10938c-0.023438-0.11328-0.070312-0.19531-0.14062-0.25-0.0625-0.050781-0.14062-0.078125-0.23438-0.078125-0.14844 0-0.26172 0.046875-0.34375 0.14062-0.074219 0.09375-0.10938 0.25-0.10938 0.46875 0 0.25 0.039063 0.42969 0.125 0.53125 0.082031 0.09375 0.19141 0.14062 0.32812 0.14062 0.10156 0 0.1875-0.023438 0.25-0.078125 0.070312-0.0625 0.11719-0.16406 0.14062-0.3125l0.54688 0.09375c-0.054688 0.25-0.16406 0.4375-0.32812 0.5625-0.15625 0.125-0.37109 0.1875-0.64062 0.1875-0.30469 0-0.54297-0.09375-0.71875-0.28125-0.17969-0.19531-0.26562-0.46094-0.26562-0.79688 0-0.34375 0.085937-0.60938 0.26562-0.79688 0.17578-0.19531 0.42188-0.29688 0.73438-0.29688 0.25 0 0.44531 0.058594 0.59375 0.17188 0.15625 0.10547 0.26562 0.26562 0.32812 0.48438z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-21-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.25-2.0781h0.5v0.28125c0.1875-0.21875 0.40625-0.32812 0.65625-0.32812 0.125 0 0.23438 0.03125 0.32812 0.09375 0.10156 0.054688 0.1875 0.13281 0.25 0.23438 0.09375-0.10156 0.19141-0.17969 0.29688-0.23438 0.10156-0.0625 0.21875-0.09375 0.34375-0.09375 0.14453 0 0.26953 0.03125 0.375 0.09375 0.10156 0.0625 0.17969 0.15625 0.23438 0.28125 0.039063 0.085938 0.0625 0.22656 0.0625 0.42188v1.3281h-0.54688v-1.1875c0-0.20703-0.023438-0.33594-0.0625-0.39062-0.054688-0.082031-0.13281-0.125-0.23438-0.125-0.074219 0-0.14844 0.027344-0.21875 0.078125-0.0625 0.042969-0.10938 0.10938-0.14062 0.20312-0.03125 0.085937-0.046875 0.22656-0.046875 0.42188v1h-0.54688v-1.1406c0-0.19531-0.011719-0.32031-0.03125-0.375-0.023438-0.0625-0.054688-0.10938-0.09375-0.14062-0.042969-0.03125-0.09375-0.046875-0.15625-0.046875-0.085938 0-0.16406 0.027344-0.23438 0.078125-0.0625 0.042969-0.10938 0.10547-0.14062 0.1875-0.03125 0.085938-0.046875 0.22656-0.046875 0.42188v1.0156h-0.54688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-21-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.5781 0h-0.54688v-2.0625c-0.21094 0.1875-0.44922 0.32422-0.71875 0.40625v-0.5c0.14453-0.039062 0.30078-0.125 0.46875-0.25 0.16406-0.13281 0.28125-0.28906 0.34375-0.46875h0.45312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-21-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.0312-2.1562-0.53125 0.046875c-0.011719-0.10156-0.046875-0.17969-0.10938-0.23438-0.054687-0.050781-0.12109-0.078125-0.20312-0.078125-0.11719 0-0.21484 0.054687-0.29688 0.15625-0.085937 0.10547-0.13672 0.32031-0.15625 0.64062 0.13281-0.15625 0.30469-0.23438 0.51562-0.23438 0.22656 0 0.42188 0.089844 0.57812 0.26562 0.16406 0.16797 0.25 0.39062 0.25 0.67188 0 0.29297-0.089844 0.52734-0.26562 0.70312-0.16797 0.17969-0.38672 0.26562-0.65625 0.26562-0.28125 0-0.51562-0.10938-0.70312-0.32812-0.1875-0.22656-0.28125-0.59766-0.28125-1.1094 0-0.53125 0.09375-0.91016 0.28125-1.1406 0.19531-0.22656 0.45312-0.34375 0.76562-0.34375 0.21875 0 0.39453 0.0625 0.53125 0.1875 0.14453 0.11719 0.23828 0.29297 0.28125 0.53125zm-1.25 1.1875c0 0.17969 0.039062 0.32031 0.125 0.42188 0.082031 0.09375 0.17578 0.14062 0.28125 0.14062 0.10156 0 0.1875-0.035156 0.25-0.10938 0.070312-0.082031 0.10938-0.21875 0.10938-0.40625s-0.039063-0.32031-0.10938-0.40625c-0.074219-0.082031-0.16797-0.125-0.28125-0.125-0.10547 0-0.19531 0.042969-0.26562 0.125-0.074219 0.085937-0.10938 0.20312-0.10938 0.35938z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-21-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.0312-0.51562v0.51562h-1.9375c0.019531-0.19531 0.082031-0.37891 0.1875-0.54688 0.10156-0.17578 0.3125-0.40625 0.625-0.6875 0.25-0.22656 0.39844-0.38281 0.45312-0.46875 0.070313-0.11328 0.10938-0.22656 0.10938-0.34375 0-0.11328-0.03125-0.20312-0.09375-0.26562-0.0625-0.070312-0.15234-0.10938-0.26562-0.10938-0.11719 0-0.21094 0.039063-0.28125 0.10938-0.0625 0.0625-0.10156 0.17969-0.10938 0.34375l-0.54688-0.0625c0.03125-0.30078 0.12891-0.51562 0.29688-0.64062 0.17578-0.13281 0.39062-0.20312 0.64062-0.20312 0.28906 0 0.51562 0.078125 0.67188 0.23438 0.16406 0.14844 0.25 0.33594 0.25 0.5625 0 0.125-0.027344 0.25-0.078125 0.375-0.042969 0.11719-0.11719 0.23438-0.21875 0.35938-0.0625 0.085938-0.18359 0.21094-0.35938 0.375-0.17969 0.15625-0.28906 0.26172-0.32812 0.3125-0.042969 0.054688-0.078125 0.10156-0.10938 0.14062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-21-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.28125-2.3594v-0.5h0.5625v0.5zm0 2.3594v-2.0781h0.5625v2.0781z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-21-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.1719 0h-0.54688v-1.0625c0-0.21875-0.011719-0.35938-0.03125-0.42188-0.023438-0.070313-0.0625-0.125-0.125-0.15625-0.054688-0.039063-0.11719-0.0625-0.1875-0.0625-0.09375 0-0.17969 0.027344-0.25 0.078125-0.074219 0.054688-0.125 0.125-0.15625 0.21875-0.03125 0.085938-0.046875 0.24219-0.046875 0.46875v0.9375h-0.54688v-2.0781h0.51562v0.3125c0.17578-0.23828 0.40625-0.35938 0.6875-0.35938 0.11328 0 0.21875 0.027344 0.3125 0.078125 0.10156 0.042969 0.17969 0.10156 0.23438 0.17188 0.050781 0.0625 0.085938 0.13672 0.10938 0.21875 0.019531 0.085938 0.03125 0.20312 0.03125 0.35938z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-21-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.28125 0v-0.54688h0.5625v0.54688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.21875 0v-2.1406h0.64062l0.39062 1.4531 0.39062-1.4531h0.64062v2.1406h-0.39062v-1.6875l-0.4375 1.6875h-0.40625l-0.4375-1.6875v1.6875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.21875 0v-2.1406h1.5938v0.35938h-1.1562v0.46875h1.0781v0.35938h-1.0781v0.59375h1.2031v0.35938z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.21875-2.1406h0.79688c0.17578 0 0.3125 0.011719 0.40625 0.03125 0.125 0.042969 0.22656 0.10938 0.3125 0.20312 0.09375 0.09375 0.16016 0.21094 0.20312 0.34375 0.050781 0.13672 0.078125 0.30859 0.078125 0.51562 0 0.17969-0.023437 0.32812-0.0625 0.45312-0.054687 0.15625-0.13281 0.28125-0.23438 0.375-0.074219 0.074219-0.17188 0.13281-0.29688 0.17188-0.10547 0.03125-0.23438 0.046875-0.39062 0.046875h-0.8125zm0.4375 0.35938v1.4219h0.3125c0.125 0 0.21094-0.003906 0.26562-0.015625 0.070313-0.019531 0.12891-0.050781 0.17188-0.09375 0.050781-0.039062 0.085938-0.10938 0.10938-0.20312 0.03125-0.10156 0.046875-0.23828 0.046875-0.40625 0-0.16406-0.015625-0.28906-0.046875-0.375-0.023437-0.09375-0.058594-0.16016-0.10938-0.20312-0.054688-0.050781-0.12109-0.085938-0.20312-0.10938-0.0625-0.007813-0.18359-0.015625-0.35938-0.015625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.20312 0v-2.1406h0.4375v2.1406z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.1562 0h-0.46875l-0.1875-0.48438h-0.85938l-0.1875 0.48438h-0.45312l0.84375-2.1406h0.45312zm-0.79688-0.84375-0.29688-0.79688-0.29688 0.79688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0.03125 0.53125-2.2188h0.3125l-0.54688 2.2188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.70312 0v-1.7812h-0.64062v-0.35938h1.7031v0.35938h-0.625v1.7812z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.21875 0v-2.1406h0.42188l0.89062 1.4219v-1.4219h0.39062v2.1406h-0.4375l-0.85938-1.4062v1.4062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.21875 0v-2.1406h0.4375v0.84375h0.84375v-0.84375h0.4375v2.1406h-0.4375v-0.9375h-0.84375v0.9375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.125-1.0625c0-0.21875 0.035156-0.39844 0.10938-0.54688 0.039063-0.11328 0.10156-0.21094 0.1875-0.29688 0.09375-0.082031 0.1875-0.14453 0.28125-0.1875 0.13281-0.0625 0.28906-0.09375 0.46875-0.09375 0.3125 0 0.5625 0.10156 0.75 0.29688 0.19531 0.19922 0.29688 0.46875 0.29688 0.8125 0 0.35547-0.10156 0.63281-0.29688 0.82812-0.1875 0.1875-0.4375 0.28125-0.75 0.28125s-0.57031-0.09375-0.76562-0.28125c-0.1875-0.19531-0.28125-0.46875-0.28125-0.8125zm0.45312-0.015625c0 0.25 0.054687 0.4375 0.17188 0.5625 0.11328 0.125 0.25391 0.1875 0.42188 0.1875 0.17578 0 0.31641-0.0625 0.42188-0.1875 0.11328-0.125 0.17188-0.3125 0.17188-0.5625s-0.058594-0.42969-0.17188-0.54688c-0.10547-0.125-0.24609-0.1875-0.42188-0.1875-0.17969 0-0.32422 0.0625-0.4375 0.1875-0.10547 0.11719-0.15625 0.29688-0.15625 0.54688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.10938-0.70312 0.42188-0.03125c0.019531 0.13672 0.066406 0.24219 0.14062 0.3125 0.082031 0.0625 0.19141 0.09375 0.32812 0.09375 0.13281 0 0.23828-0.023437 0.3125-0.078125 0.070312-0.0625 0.10938-0.13281 0.10938-0.21875 0-0.050781-0.015625-0.09375-0.046875-0.125-0.03125-0.039062-0.085938-0.070312-0.15625-0.09375-0.054688-0.019531-0.16797-0.050781-0.34375-0.09375-0.23047-0.0625-0.39062-0.13281-0.48438-0.21875-0.13672-0.11328-0.20312-0.25391-0.20312-0.42188 0-0.11328 0.03125-0.21875 0.09375-0.3125s0.14844-0.16406 0.26562-0.21875c0.11328-0.050781 0.25391-0.078125 0.42188-0.078125 0.26953 0 0.47266 0.0625 0.60938 0.1875 0.13281 0.11719 0.20703 0.27344 0.21875 0.46875l-0.4375 0.015625c-0.023437-0.11328-0.0625-0.19141-0.125-0.23438-0.054687-0.050781-0.14062-0.078125-0.26562-0.078125s-0.22656 0.027344-0.29688 0.078125c-0.054687 0.03125-0.078125 0.078125-0.078125 0.14062 0 0.054687 0.023438 0.09375 0.078125 0.125 0.050781 0.042969 0.17969 0.089844 0.39062 0.14062 0.20703 0.054688 0.36328 0.10547 0.46875 0.15625 0.10156 0.054688 0.17969 0.125 0.23438 0.21875 0.0625 0.09375 0.09375 0.21094 0.09375 0.34375 0 0.125-0.039063 0.24219-0.10938 0.34375-0.0625 0.10547-0.15625 0.18359-0.28125 0.23438-0.125 0.050781-0.28125 0.078125-0.46875 0.078125-0.27344 0-0.48047-0.0625-0.625-0.1875-0.14844-0.125-0.23438-0.30469-0.26562-0.54688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.03125 0v-0.39062l1.125-1.3906h-1v-0.35938h1.5781v0.32812l-1.1719 1.4531h1.2188v0.35938z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.23438 0v-2.125h0.42188v1.7656h1.0781v0.35938z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.21875-2.1406h0.4375v1.1562c0 0.1875 0.003906 0.30859 0.015625 0.35938 0.007813 0.085938 0.050781 0.15625 0.125 0.21875 0.070313 0.054688 0.16406 0.078125 0.28125 0.078125 0.125 0 0.21875-0.023437 0.28125-0.078125 0.0625-0.050781 0.097656-0.11328 0.10938-0.1875 0.019531-0.070312 0.03125-0.19141 0.03125-0.35938v-1.1875h0.42188v1.125c0 0.25-0.011719 0.43359-0.03125 0.54688-0.023437 0.10547-0.0625 0.19531-0.125 0.26562-0.0625 0.074219-0.14844 0.13281-0.25 0.17188-0.10547 0.039062-0.24609 0.0625-0.42188 0.0625-0.19922 0-0.35547-0.023438-0.46875-0.0625-0.10547-0.050781-0.1875-0.11328-0.25-0.1875-0.0625-0.070312-0.10156-0.14844-0.10938-0.23438-0.03125-0.125-0.046875-0.30469-0.046875-0.54688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.21875 0v-2.1406h0.90625c0.23828 0 0.40625 0.023437 0.5 0.0625 0.10156 0.03125 0.1875 0.10156 0.25 0.20312 0.0625 0.09375 0.09375 0.20312 0.09375 0.32812 0 0.16797-0.046875 0.30469-0.14062 0.40625-0.09375 0.10547-0.23438 0.16797-0.42188 0.1875 0.09375 0.0625 0.17188 0.125 0.23438 0.1875s0.14453 0.17969 0.25 0.34375l0.26562 0.42188h-0.53125l-0.3125-0.46875c-0.10547-0.16406-0.17969-0.26953-0.21875-0.3125-0.042969-0.039062-0.089844-0.066406-0.14062-0.078125-0.042969-0.019531-0.11719-0.03125-0.21875-0.03125h-0.078125v0.89062zm0.4375-1.2344h0.3125c0.20703 0 0.33594-0.00781 0.39062-0.03125 0.050781-0.019531 0.09375-0.050781 0.125-0.09375 0.03125-0.039063 0.046875-0.09375 0.046875-0.15625 0-0.070313-0.023438-0.12891-0.0625-0.17188-0.042969-0.050781-0.09375-0.082031-0.15625-0.09375h-0.65624z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.2188-0.79688v-0.35938h0.9375v0.85938c-0.09375 0.085937-0.23047 0.16406-0.40625 0.23438-0.16797 0.0625-0.33984 0.09375-0.51562 0.09375-0.23047 0-0.42969-0.046875-0.59375-0.14062-0.16797-0.09375-0.29297-0.22266-0.375-0.39062-0.085937-0.17578-0.125-0.36719-0.125-0.57812 0-0.22656 0.046875-0.42578 0.14062-0.59375 0.09375-0.17578 0.23438-0.3125 0.42188-0.40625 0.13281-0.070313 0.30078-0.10938 0.5-0.10938 0.26953 0 0.47656 0.058594 0.625 0.17188 0.15625 0.11719 0.25391 0.27344 0.29688 0.46875l-0.4375 0.078125c-0.03125-0.10156-0.089844-0.1875-0.17188-0.25-0.085937-0.0625-0.1875-0.09375-0.3125-0.09375-0.1875 0-0.33984 0.0625-0.45312 0.1875-0.10547 0.11719-0.15625 0.29297-0.15625 0.53125 0 0.25 0.054688 0.44531 0.17188 0.57812 0.11328 0.125 0.25781 0.1875 0.4375 0.1875 0.09375 0 0.17969-0.015625 0.26562-0.046875 0.09375-0.039062 0.17578-0.085938 0.25-0.14062v-0.28125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.125-1.0625c0-0.21875 0.035156-0.39844 0.10938-0.54688 0.039063-0.11328 0.10156-0.21094 0.1875-0.29688 0.09375-0.082031 0.1875-0.14453 0.28125-0.1875 0.13281-0.0625 0.28906-0.09375 0.46875-0.09375 0.3125 0 0.5625 0.10156 0.75 0.29688 0.19531 0.19922 0.29688 0.46875 0.29688 0.8125 0 0.35547-0.10156 0.63281-0.29688 0.82812-0.1875 0.1875-0.4375 0.28125-0.75 0.28125s-0.57031-0.09375-0.76562-0.28125c-0.1875-0.19531-0.28125-0.46875-0.28125-0.8125zm0.45312-0.015625c0 0.25 0.054687 0.4375 0.17188 0.5625 0.11328 0.125 0.25391 0.1875 0.42188 0.1875 0.17578 0 0.31641-0.0625 0.42188-0.1875 0.11328-0.125 0.17188-0.3125 0.17188-0.5625s-0.058594-0.42969-0.17188-0.54688c-0.10547-0.125-0.24609-0.1875-0.42188-0.1875-0.17969 0-0.32422 0.0625-0.4375 0.1875-0.10547 0.11719-0.15625 0.29688-0.15625 0.54688zm0.0625-1.1875v-0.35938h0.35938v0.35938zm0.64062 0v-0.35938h0.34375v0.35938z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.21875 0v-2.1406h0.70312c0.25781 0 0.42969 0.011719 0.51562 0.03125 0.11328 0.03125 0.21094 0.10156 0.29688 0.20312 0.082031 0.10547 0.125 0.24609 0.125 0.42188 0 0.125-0.027344 0.23438-0.078125 0.32812-0.042969 0.09375-0.10156 0.16797-0.17188 0.21875-0.074219 0.054688-0.14844 0.085938-0.21875 0.09375-0.10547 0.023438-0.25781 0.03125-0.45312 0.03125h-0.28125v0.8125zm0.4375-1.7812v0.60938h0.23438c0.16406 0 0.27344-0.00781 0.32812-0.03125 0.0625-0.03125 0.10938-0.066406 0.14062-0.10938 0.039063-0.050781 0.0625-0.10938 0.0625-0.17188 0-0.070313-0.027344-0.13281-0.078125-0.1875-0.042969-0.050781-0.10156-0.082031-0.17188-0.09375-0.054687-0.007813-0.15625-0.015625-0.3125-0.015625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.21875-2.1406h0.85938c0.16406 0 0.28906 0.00781 0.375 0.015625 0.082031 0.011719 0.15625 0.042969 0.21875 0.09375 0.070313 0.042969 0.12891 0.10156 0.17188 0.17188 0.039062 0.074219 0.0625 0.15625 0.0625 0.25 0 0.10547-0.027344 0.19922-0.078125 0.28125-0.054687 0.085937-0.125 0.14844-0.21875 0.1875 0.13281 0.042969 0.23438 0.10938 0.29688 0.20312 0.070312 0.085938 0.10938 0.1875 0.10938 0.3125 0 0.10547-0.027344 0.20312-0.078125 0.29688-0.042969 0.085937-0.10547 0.15625-0.1875 0.21875-0.074219 0.054688-0.16797 0.085938-0.28125 0.09375-0.074219 0.011719-0.24609 0.015625-0.51562 0.015625h-0.73438zm0.4375 0.34375v0.5h0.59375c0.070312-0.00781 0.12891-0.035156 0.17188-0.078125 0.039063-0.039062 0.0625-0.097656 0.0625-0.17188 0-0.0625-0.023437-0.11328-0.0625-0.15625-0.03125-0.039063-0.085937-0.066406-0.15625-0.078125-0.042969-0.007812-0.16406-0.015625-0.35938-0.015625zm0 0.85938v0.57812h0.40625c0.15625 0 0.25391-0.003906 0.29688-0.015625 0.0625-0.007812 0.11328-0.035156 0.15625-0.078125 0.039063-0.050781 0.0625-0.11328 0.0625-0.1875 0-0.0625-0.015625-0.11328-0.046875-0.15625-0.03125-0.050781-0.078125-0.085937-0.14062-0.10938-0.0625-0.019531-0.19531-0.03125-0.39062-0.03125z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#231f20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m105.91 99.957v-0.15234h-83.086v-25.914h82.938v26.066h0.14844v-0.15234 0.15234h0.15234v-26.367h-83.539v26.516h83.539v-0.14844"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.613 84.266h83.305v-0.30078h-83.305z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-217.86 -397.41)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    x: 254.94099,
    y: 488.99899,
    xlinkHref: "#glyph-21-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 257.16501,
    y: 488.99899,
    xlinkHref: "#glyph-21-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 259.38901,
    y: 488.99899,
    xlinkHref: "#glyph-21-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 261.61301,
    y: 488.99899,
    xlinkHref: "#glyph-21-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 263.83701,
    y: 488.99899,
    xlinkHref: "#glyph-21-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 266.061,
    y: 488.99899,
    xlinkHref: "#glyph-21-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 268.285,
    y: 488.99899,
    xlinkHref: "#glyph-21-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 270.509,
    y: 488.99899,
    xlinkHref: "#glyph-21-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 272.733,
    y: 488.99899,
    xlinkHref: "#glyph-21-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 273.845,
    y: 488.99899,
    xlinkHref: "#glyph-21-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 276.069,
    y: 488.99899,
    xlinkHref: "#glyph-21-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 255.49686,
    y: 493.99899,
    xlinkHref: "#glyph-21-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 257.72086,
    y: 493.99899,
    xlinkHref: "#glyph-21-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 259.94485,
    y: 493.99899,
    xlinkHref: "#glyph-21-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 262.16885,
    y: 493.99899,
    xlinkHref: "#glyph-21-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 264.39285,
    y: 493.99899,
    xlinkHref: "#glyph-21-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 266.61685,
    y: 493.99899,
    xlinkHref: "#glyph-21-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 268.84085,
    y: 493.99899,
    xlinkHref: "#glyph-21-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 271.06485,
    y: 493.99899,
    xlinkHref: "#glyph-21-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 273.28885,
    y: 493.99899,
    xlinkHref: "#glyph-21-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 274.40085,
    y: 493.99899,
    xlinkHref: "#glyph-21-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 275.51285,
    y: 493.99899,
    xlinkHref: "#glyph-21-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 277.95685,
    y: 493.99899,
    xlinkHref: "#glyph-21-12"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-217.86 -397.41)",
    fill: "#171817"
  }, /*#__PURE__*/React.createElement("use", {
    x: 241.77299,
    y: 474.83499,
    xlinkHref: "#glyph-22-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 244.272,
    y: 474.83499,
    xlinkHref: "#glyph-22-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 246.27299,
    y: 474.83499,
    xlinkHref: "#glyph-22-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 248.439,
    y: 474.83499,
    xlinkHref: "#glyph-22-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 249.27299,
    y: 474.83499,
    xlinkHref: "#glyph-22-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 251.439,
    y: 474.83499,
    xlinkHref: "#glyph-22-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 254.33301,
    y: 474.83499,
    xlinkHref: "#glyph-22-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 255.16847,
    y: 474.83499,
    xlinkHref: "#glyph-22-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 256.00848,
    y: 474.83499,
    xlinkHref: "#glyph-22-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 257.61871,
    y: 474.83499,
    xlinkHref: "#glyph-22-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 259.7847,
    y: 474.83499,
    xlinkHref: "#glyph-22-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 262.28369,
    y: 474.83499,
    xlinkHref: "#glyph-22-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 264.44971,
    y: 474.83499,
    xlinkHref: "#glyph-22-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 266.61569,
    y: 474.83499,
    xlinkHref: "#glyph-22-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 268.78171,
    y: 474.83499,
    xlinkHref: "#glyph-22-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 271.11569,
    y: 474.83499,
    xlinkHref: "#glyph-22-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 271.95422,
    y: 474.83499,
    xlinkHref: "#glyph-22-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 272.78967,
    y: 474.83499,
    xlinkHref: "#glyph-22-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 273.62967,
    y: 474.83499,
    xlinkHref: "#glyph-22-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 275.63068,
    y: 474.83499,
    xlinkHref: "#glyph-22-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 276.46466,
    y: 474.83499,
    xlinkHref: "#glyph-22-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 278.29767,
    y: 474.83499,
    xlinkHref: "#glyph-22-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 280.29868,
    y: 474.83499,
    xlinkHref: "#glyph-22-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 281.13721,
    y: 474.83499,
    xlinkHref: "#glyph-22-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 281.97269,
    y: 474.83499,
    xlinkHref: "#glyph-22-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 282.81268,
    y: 474.83499,
    xlinkHref: "#glyph-22-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 284.42258,
    y: 474.83499,
    xlinkHref: "#glyph-22-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 286.58859,
    y: 474.83499,
    xlinkHref: "#glyph-22-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 287.42258,
    y: 474.83499,
    xlinkHref: "#glyph-22-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 289.25558,
    y: 474.83499,
    xlinkHref: "#glyph-22-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 291.08859,
    y: 474.83499,
    xlinkHref: "#glyph-22-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 293.08957,
    y: 474.83499,
    xlinkHref: "#glyph-22-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 293.9281,
    y: 474.83499,
    xlinkHref: "#glyph-22-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 294.76355,
    y: 474.83499,
    xlinkHref: "#glyph-22-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 295.60355,
    y: 474.83499,
    xlinkHref: "#glyph-22-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 298.10257,
    y: 474.83499,
    xlinkHref: "#glyph-22-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 300.26855,
    y: 474.83499,
    xlinkHref: "#glyph-22-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 302.21201,
    y: 474.83499,
    xlinkHref: "#glyph-22-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 304.04498,
    y: 474.83499,
    xlinkHref: "#glyph-22-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 304.88354,
    y: 474.83499,
    xlinkHref: "#glyph-22-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 305.71899,
    y: 474.83499,
    xlinkHref: "#glyph-22-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 306.55899,
    y: 474.83499,
    xlinkHref: "#glyph-22-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 309.05798,
    y: 474.83499,
    xlinkHref: "#glyph-22-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 309.892,
    y: 474.83499,
    xlinkHref: "#glyph-22-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 311.89301,
    y: 474.83499,
    xlinkHref: "#glyph-22-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 314.05899,
    y: 474.83499,
    xlinkHref: "#glyph-22-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 316.22501,
    y: 474.83499,
    xlinkHref: "#glyph-22-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 318.22598,
    y: 474.83499,
    xlinkHref: "#glyph-22-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 319.06454,
    y: 474.83499,
    xlinkHref: "#glyph-22-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 241.77299,
    y: 478.83383,
    xlinkHref: "#glyph-22-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 244.10699,
    y: 478.83383,
    xlinkHref: "#glyph-22-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 246.27299,
    y: 478.83383,
    xlinkHref: "#glyph-22-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 248.60699,
    y: 478.83383,
    xlinkHref: "#glyph-22-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 250.608,
    y: 478.83383,
    xlinkHref: "#glyph-22-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 252.60899,
    y: 478.83383,
    xlinkHref: "#glyph-22-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 254.57254,
    y: 478.83383,
    xlinkHref: "#glyph-22-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 255.408,
    y: 478.83383,
    xlinkHref: "#glyph-22-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 257.37299,
    y: 478.83383,
    xlinkHref: "#glyph-22-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 259.87201,
    y: 478.83383,
    xlinkHref: "#glyph-22-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 261.87299,
    y: 478.83383,
    xlinkHref: "#glyph-22-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 263.70599,
    y: 478.83383,
    xlinkHref: "#glyph-22-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 265.707,
    y: 478.83383,
    xlinkHref: "#glyph-22-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 268.04099,
    y: 478.83383,
    xlinkHref: "#glyph-22-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 270.00629,
    y: 478.83383,
    xlinkHref: "#glyph-22-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 272.80853,
    y: 478.83383,
    xlinkHref: "#glyph-22-19"
  }), /*#__PURE__*/React.createElement("use", {
    x: 274.97455,
    y: 478.83383,
    xlinkHref: "#glyph-22-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 276.97552,
    y: 478.83383,
    xlinkHref: "#glyph-22-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 279.14154,
    y: 478.83383,
    xlinkHref: "#glyph-22-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 281.14255,
    y: 478.83383,
    xlinkHref: "#glyph-22-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 283.30853,
    y: 478.83383,
    xlinkHref: "#glyph-22-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 285.27206,
    y: 478.83383,
    xlinkHref: "#glyph-22-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 286.10754,
    y: 478.83383,
    xlinkHref: "#glyph-22-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 288.07254,
    y: 478.83383,
    xlinkHref: "#glyph-22-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 290.23853,
    y: 478.83383,
    xlinkHref: "#glyph-22-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 292.57254,
    y: 478.83383,
    xlinkHref: "#glyph-22-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 294.40555,
    y: 478.83383,
    xlinkHref: "#glyph-22-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 296.90454,
    y: 478.83383,
    xlinkHref: "#glyph-22-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 297.73853,
    y: 478.83383,
    xlinkHref: "#glyph-22-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 299.90454,
    y: 478.83383,
    xlinkHref: "#glyph-22-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 302.07053,
    y: 478.83383,
    xlinkHref: "#glyph-22-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 304.03598,
    y: 478.83383,
    xlinkHref: "#glyph-22-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 306.83823,
    y: 478.83383,
    xlinkHref: "#glyph-22-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 309.33722,
    y: 478.83383,
    xlinkHref: "#glyph-22-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 311.50323,
    y: 478.83383,
    xlinkHref: "#glyph-22-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 313.50424,
    y: 478.83383,
    xlinkHref: "#glyph-22-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 315.67023,
    y: 478.83383,
    xlinkHref: "#glyph-22-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 317.83621,
    y: 478.83383,
    xlinkHref: "#glyph-22-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 230.90791,
    y: 505.69699,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 232.09482,
    y: 505.69699,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 241.71123,
    y: 505.69699,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 242.89873,
    y: 505.69699,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 253.98405,
    y: 505.69699,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 255.17139,
    y: 505.69699,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 265.41043,
    y: 505.69699,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 266.59796,
    y: 505.69699,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 275.18112,
    y: 505.69699,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 284.9173,
    y: 505.69699,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 286.10458,
    y: 505.69699,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 294.21103,
    y: 505.69699,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 295.39832,
    y: 505.69699,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 306.07095,
    y: 505.69699,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 307.25809,
    y: 505.69699,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 315.24731,
    y: 505.69699,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 316.4346,
    y: 505.69699,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 329.59476,
    y: 505.69699,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 330.78186,
    y: 505.69699,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 339.4635,
    y: 505.69699,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 230.14249,
    y: 509.49857,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 231.13545,
    y: 509.49857,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 229.6772,
    y: 519.49701,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 238.31236,
    y: 519.49701,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 250.15494,
    y: 519.49701,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 255.53891,
    y: 519.49701,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 276.84741,
    y: 519.49701,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 281.54819,
    y: 519.49701,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 292.98602,
    y: 519.49701,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 305.44858,
    y: 519.49701,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 307.70444,
    y: 519.49701,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 319.85794,
    y: 519.49701,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 320.41293,
    y: 519.49701,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 326.50906,
    y: 519.49701,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 248.34476,
    y: 523.29816,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 253.62915,
    y: 523.29816,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 285.44827,
    y: 523.29816,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 293.62247,
    y: 523.29816,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 323.29919,
    y: 523.29816,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 331.93707,
    y: 523.29816,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 229.59088,
    y: 527.09973,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 234.77249,
    y: 527.09973,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 249.79327,
    y: 527.09973,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 271.57251,
    y: 527.09973,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 289.65082,
    y: 527.09973,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 295.91745,
    y: 527.09973,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 305.44501,
    y: 527.09973,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 313.65146,
    y: 527.09973,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 322.67371,
    y: 527.09973,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 334.69833,
    y: 527.09973,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 228.03117,
    y: 530.90131,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 244.10968,
    y: 530.90131,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 256.39249,
    y: 530.90131,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 262.03098,
    y: 530.90131,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 267.70068,
    y: 530.90131,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 268.23468,
    y: 530.90131,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 284.29053,
    y: 530.90131,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 288.52881,
    y: 530.90131,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 295.20413,
    y: 530.90131,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 305.73697,
    y: 530.90131,
    xlinkHref: "#glyph-5-9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m127.81 176v-0.25h-127.31v-175.25h127.06v175.5h0.25v-0.25 0.25h0.25v-176h-128.06v176.25h128.06v-0.25zm-59.527-160.16h-0.25c0 1.1055-0.44922 2.1016-1.1719 2.8281-0.72657 0.72265-1.7266 1.1719-2.832 1.1719-1.1055 0-2.1055-0.44922-2.8281-1.1719-0.72656-0.72657-1.1719-1.7227-1.1719-2.8281 0-1.1094 0.44532-2.1055 1.1719-2.832 0.72266-0.72266 1.7227-1.1719 2.8281-1.1719 1.1055 0 2.1055 0.44921 2.832 1.1719 0.72265 0.72656 1.1719 1.7227 1.1719 2.832h0.5c0-2.4883-2.0156-4.5039-4.5039-4.5039-2.4844 0-4.5 2.0156-4.5 4.5039 0 2.4844 2.0156 4.5 4.5 4.5 2.4883 0 4.5039-2.0156 4.5039-4.5",
    fill: "#4f5257"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m1.8516 5.3555h17.617c5.0469 0 9.1523 4.1562 9.1523 9.2617v53.102h-17.617c-5.0469 0-9.1523-4.1523-9.1523-9.2578",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m15.098 65.594h11.398v-31.844c0-3.9336-3.1523-7.1328-7.0273-7.1328h-11.398v31.844c0 3.9336 3.1523 7.1328 7.0273 7.1328",
    fill: "#171817"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m15.098 64.887c-3.4805 0-6.3164-2.8828-6.3164-6.4258v-31.137h10.691c3.4805 0 6.3164 2.8828 6.3164 6.4258v31.137",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m8.0703 58.461c0 3.9336 3.1523 7.1328 7.0273 7.1328h11.398v-22.676l-9.2109 4.5391-9.2148-4.543",
    fill: "#171817"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m15.098 64.887c-3.4844 0-6.3164-2.8828-6.3164-6.4258v-14.406l8.5039 4.1914 8.5-4.1875 4e-3 20.828",
    fill: "#171817"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.363 60.547h-0.44922l-0.10547 0.0117c0.21094-2.3477 0.53516-5.9688 0.69141-7.6094 0.0195-0.16797-0.10547-0.31641-0.27344-0.33203-0.16797-0.0195-0.3164 0.10547-0.33203 0.27344-0.24219 2.5195-0.8789 9.7109-0.88672 9.7852-0.0117 0.1211-0.13281 0.21875-0.26953 0.21875h-4.9102c-0.13672 0-0.25782-0.0976-0.26954-0.21875-4e-3 -0.0742-0.64453-7.2656-0.88671-9.7852-0.0156-0.16797-0.16407-0.29297-0.33204-0.27344-0.16796 0.0156-0.28906 0.16406-0.27343 0.33203 0.15625 1.6406 0.48437 5.2578 0.69531 7.6094l-0.10938-0.0117h-0.44921c-0.29297 0-0.52735 0.23437-0.52735 0.52734v1.9023c0 0.29297 0.23438 0.52735 0.52735 0.52735h0.44921c0.21875 0 0.40625-0.13281 0.48829-0.32422 0.16015 0.19922 0.41015 0.32422 0.6875 0.32422h4.9102c0.28125 0 0.52735-0.125 0.6875-0.32422 0.082 0.19141 0.26953 0.32812 0.48828 0.32812h0.44922c0.29297 0 0.53125-0.23828 0.53125-0.53125v-1.9023c0-0.28906-0.23828-0.52734-0.53125-0.52734"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.672 50.168h-0.52344l-0.71485-0.625c-0.15234-0.13281-0.38281-0.21094-0.625-0.21094h-5.0508c-0.24218 0-0.46875 0.0781-0.62109 0.21094l-0.71484 0.625h-0.52344c-0.33594 0-0.60547 0.28125-0.60547 0.63281v0.80078c0 0.11329 0.0273 0.22266 0.082 0.32032l0.0977 0.10156c0.0937 0.0664 0.20703 0.10156 0.32422 0.10156h8.9766c0.11328 0 0.22656-0.0351 0.32422-0.10156l0.0937-0.10156c0.0547-0.0977 0.0859-0.20703 0.0859-0.32032v-0.80078c0-0.35156-0.27343-0.63281-0.60546-0.63281m8e-3 1.3633h-8.7931v-0.73047l0.0117-0.0391h0.63281l0.19922-0.0742 0.79687-0.69922c0.0352-0.0312 0.1211-0.0625 0.23047-0.0625h5.0508c0.10938 0 0.19922 0.0312 0.23438 0.0625l0.79687 0.69922 0.19532 0.0742h0.63672l8e-3 0.0391"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.809 50.203h-5.0508c-0.13672 0-0.25 0.11328-0.25 0.25 0 0.14062 0.11328 0.2539 0.25 0.2539h5.0508c0.13672 0 0.25-0.11328 0.25-0.2539 0-0.13672-0.11328-0.25-0.25-0.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.758 55.973c-0.0664-0.15625-0.24218-0.22656-0.39453-0.16406-0.15234 0.0625-0.22265 0.23828-0.16015 0.39062 0.10546 0.25391 0.15625 0.52344 0.15625 0.79688 0 1.1445-0.92969 2.0742-2.0742 2.0742s-2.0781-0.92968-2.0781-2.0742c0-1.1445 0.9336-2.0781 2.0781-2.0781l0.0234 4e-3 -0.42968 0.42578c-0.11719 0.11719-0.11719 0.30859 0 0.42578l0.21093 0.0859 0.21485-0.0859 0.9414-0.94141c0.11719-0.11718 0.11719-0.30859 0-0.42578l-0.9414-0.9414c-0.11719-0.11719-0.3086-0.11719-0.42578 0-0.11719 0.11718-0.11719 0.30859 0 0.42578l0.43359 0.42968h-0.0273c-1.4766 0-2.6758 1.1992-2.6758 2.6758s1.1992 2.6758 2.6758 2.6758c1.4726 0 2.6758-1.1992 2.6758-2.6758 0-0.35547-0.0703-0.69922-0.20313-1.0234"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#040606"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.297 16.52c-0.76172 1.1172-0.11329 2.5938 0.67187 3.3398 0.71484 0.67968 1.2891 0.83984 1.3672 0.85937l0.36328-0.69922 1.0547 2.8828-2.9805 0.60546 0.39453-0.73437-0.40234-0.22656c-1.2539-0.81641-1.5195-1.9297-1.6094-2.2734-0.14844-0.59766-0.37109-2.3867 1.1406-3.7539"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.281 16.566c0.54297 1.2422 2.1328 1.4805 3.1875 1.2148 0.92969-0.23828 1.3711-0.62109 1.4492-0.6914l-4e-3 -8e-3 -0.39843-0.6914 3 0.65625-1.0898 2.8438-0.39844-0.71485-0.39453 0.21094c-1.3594 0.625-2.4414 0.25781-2.7812 0.14453-0.58593-0.1914-2.2188-0.95703-2.5703-2.9648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.586 13.57c-0.20703 1.4844-1.1016 2.1953-1.3789 2.418-0.47656 0.39063-2.0039 1.3516-3.8828 0.5625 1.3359 0.21485 2.3984-0.99609 2.7422-2.0234 0.30859-0.92579 0.21484-1.5078 0.19922-1.5977h-8e-3l-0.79687-0.0352 2.1641-2.1758 1.8125 2.4414-0.81641-0.0469"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.488 12.316c-0.68359 0-1.2383-0.55469-1.2383-1.2383 0-0.6836 0.55469-1.2383 1.2383-1.2383 0.6836 0 1.2383 0.55468 1.2383 1.2383 0 0.68359-0.55468 1.2383-1.2383 1.2383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.184 7.4844c-4.4766 0-8.1172 3.6367-8.1172 8.1133 0 4.4726 3.6406 8.1133 8.1172 8.1133 0.23829 0 0.47266-0.0156 0.70704-0.0352l0.0547 0.8125 1.4844-1.4336-1.6602-1.2656 0.0625 0.85547c-0.21484 0.0195-0.42969 0.0352-0.64844 0.0352-0.34765 0-0.68359-0.0273-1.0156-0.0742l-0.03127-0.21877-0.76953-6.5703c-0.10938-1.2383 0.60156-1.4336 1.0391-1.25l2.4609 0.98828c0.28125 0.12109 0.41797-0.11328 0.41797-0.11328s0.15625-0.25-0.125-0.42969c0 0-3.3555-2.2227-4.0703-2.3555-0.97656-0.18359-1.9414 0.60547-2.1562 1.6367l-1.1914 5.832c-1.0234-1.2266-1.6406-2.8086-1.6406-4.5273 0-3.9024 3.1758-7.082 7.082-7.082 2.082 0 3.9609 0.91015 5.2578 2.3477l0.72656-0.73828c-1.4844-1.6211-3.6172-2.6406-5.9844-2.6406m-3.6133 10.855c0.10547-0.28907 0.26172-0.26954 0.26172-0.26954s0.14453-0.0312 0.22266 0.26172l1.1562 4.0664c-0.96485-0.28516-1.8438-0.76172-2.5938-1.3945"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m4.8945 40.082v-1.4453h0.50391v0.85547h0.70703v-0.67969h0.50391v0.67969h0.78125v-0.85938h0.51171v1.4492",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m7.0781 38.449-0.0156-0.55859c0.18359-0.0156 0.39844-0.0586 0.39844-0.26953 0-0.16797-0.14453-0.21875-0.27735-0.21875-0.16406 0-0.28515 0.10546-0.44921 0.27734l-0.28516 0.28906c-0.25391 0.26953-0.5 0.4336-0.82813 0.4336-0.41796 0-0.77734-0.26172-0.77734-0.79688 0-0.375 0.19531-0.72656 0.85156-0.75l0.0156 0.51953c-0.21875 0.0234-0.39063 0.0742-0.39063 0.25781 0 0.14844 0.11328 0.21485 0.25391 0.21485 0.16016 0 0.3125-0.16406 0.44531-0.30469l0.26172-0.26562c0.27734-0.29297 0.53516-0.45704 0.87109-0.45704 0.44532 0 0.79297 0.30469 0.79297 0.80469s-0.33203 0.79297-0.86718 0.82422",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m14.234 33.645 0.23046 0.10157 0.1875-0.0664c0.125-0.0977 0.14454-0.27344 0.0391-0.39453l-0.0937-0.10547c0.10937-0.0547 0.23047-0.082 0.35547-0.082 0.23828 0 0.46484 0.0976 0.61718 0.26953 0.28125 0.32031 0.23438 0.79687-0.10547 1.0625-0.14453 0.10937-0.32421 0.17187-0.50781 0.17187-0.24219 0-0.46484-0.0976-0.61719-0.27343-0.18359-0.20703-0.22265-0.48047-0.13671-0.72266zm-1.125-1.2812 0.68359 0.77735c-0.12109 0.17187-0.20313 0.37109-0.22266 0.58593-0.0352 0.35157 0.0781 0.69141 0.3125 0.96094 0.26563 0.30078 0.65625 0.47266 1.0742 0.47266 0.32422 0 0.63672-0.10547 0.88672-0.30078 0.58984-0.46094 0.67188-1.293 0.18359-1.8477-0.26562-0.30078-0.65625-0.47656-1.0742-0.47656-0.26172 0-0.51954 0.0742-0.73829 0.20703l-0.6914-0.78516 0.0156 4e-3 0.1211-0.0234 0.0469-0.0351 0.0664 4e-3 2.9023 0.29297c0.21875 0.0234 0.54688 0.19141 0.6875 0.35156l5.7852 6.5781c0.0859 0.0976 0.0742 0.24609-0.0312 0.32812l-3.832 2.9961-0.15625 0.0508-0.19141-0.082-5.7812-6.5781c-0.14062-0.16015-0.25781-0.5-0.24609-0.70703l0.1875-2.6992zm10.496 6.4102-5.7852-6.582c-0.23828-0.26953-0.71093-0.50781-1.082-0.54688l-2.9023-0.29297-0.13672-8e-3 -0.89063-1.8516c-0.0664-0.13672-0.24609-0.20313-0.39062-0.13672l-0.15625 0.15625 8e-3 0.21094 0.81641 1.6953-0.0273 0.0117-1.1602-1.3203c-0.10156-0.11328-0.29297-0.13282-0.41797-0.0352-0.125 0.0977-0.14063 0.27344-0.0391 0.39453l1.2031 1.3633c-0.0781 0.17969-0.125 0.39063-0.13672 0.56641l-0.1875 2.6992c-0.0234 0.34765 0.14063 0.83203 0.37891 1.1016l5.7852 6.5781c0.15625 0.18359 0.39453 0.28515 0.64453 0.28515 0.19531 0 0.38672-0.0625 0.53515-0.17969l3.832-2.9961c0.17188-0.13672 0.27735-0.32422 0.29688-0.53516 0.0234-0.21093-0.0469-0.41796-0.1875-0.57812",
    fill: "#171716"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#1d1d1b",
    strokeWidth: 0.99659
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m31.93 163.19 1.2158-1.176 0.01993 0.59797h1.0464l1.0464-9e-3 0.17938-0.0598c0.09965-0.0299 0.22921-0.0997 0.29897-0.13953 0.37869-0.26908 0.46838-0.74746 0.23917-1.2657-0.0299-0.0698-0.37869-0.68767-0.77731-1.3753-0.38866-0.67771-0.70755-1.2458-0.69759-1.2558l0.93676-0.52821s0.32886 0.56807 0.71752 1.2358c0.78728 1.3654 0.85704 1.4949 0.96666 1.8039 0.40859 1.2159-0.07972 2.2026-1.2557 2.5414-0.35876 0.0997-0.39862 0.10963-1.5646 0.1196h-1.1261l-0.01993 0.69763z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m27.874 163.64c-0.76735-0.12957-1.3254-0.49832-1.5845-1.0365-0.10962-0.22923-0.14948-0.38869-0.15945-0.69764-0.01-0.31892 0.01993-0.53818 0.13952-0.887 0.09966-0.29899 0.21924-0.52821 0.67766-1.3255 0.20928-0.36875 0.38866-0.66774 0.37869-0.66774l-0.50824-0.30896 1.6244-0.45844 0.39862 1.6345-0.578-0.26909c-0.06976 0.0897-0.82714 1.4252-0.87697 1.5348-0.08969 0.18936-0.11959 0.38868-0.10962 0.57804 0.01993 0.39865 0.23917 0.66774 0.66769 0.80727l0.16941 0.0598h1.5546l1.5546 9e-3v1.0764h-1.5646c-1.4051 0-1.5945 0-1.7938-0.0399"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m28.432 157.19s1.3254-2.362 1.5048-2.6211c0.19931-0.28902 0.49828-0.59797 0.73745-0.75743 0.14948-0.0997 0.43848-0.23919 0.62783-0.27906 0.47835-0.1196 1.0264 0 1.4649 0.32889 0.21924 0.15946 0.53814 0.50828 0.70755 0.75743 0.07973 0.1196 0.32886 0.53818 0.5481 0.9169 0.21924 0.38868 0.40859 0.7076 0.40859 0.7076l0.52817-0.27905-0.40859 1.6345-1.6144-0.45844 0.53814-0.34882s-0.8371-1.465-0.93676-1.6046c-0.2591-0.36875-0.63779-0.55811-0.98659-0.48835-0.26907 0.0498-0.52817 0.23919-0.70755 0.49832-0.04983 0.0698-0.39862 0.65777-0.77731 1.3155-0.37869 0.65777-0.70755 1.196-0.71752 1.2059-0.30893-0.15946-0.62783-0.32889-0.91683-0.51825"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m31.421 160.57v0.50828h-1.9632v-0.37872l0.69759-0.74747c0.47835-0.51824 0.55807-0.65777 0.55807-0.89696s-0.16941-0.40862-0.48831-0.40862c-0.33883 0-0.578 0.12956-0.69759 0.23919v-0.60794c0.13952-0.0797 0.40859-0.18936 0.78728-0.18936 0.64776 0 1.0563 0.37872 1.0563 0.90693 0 0.41858-0.16941 0.7076-0.69759 1.2258l-0.34879 0.34882h1.1062z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m33.713 160.57v0.50828h-1.9632v-0.37872l0.69759-0.74747c0.47834-0.51824 0.55807-0.65777 0.55807-0.89696s-0.16941-0.40862-0.48831-0.40862c-0.33883 0-0.578 0.12956-0.69759 0.23919v-0.60794c0.13952-0.0797 0.40859-0.18936 0.78728-0.18936 0.64776 0 1.0563 0.37872 1.0563 0.90693 0 0.41858-0.16941 0.7076-0.69759 1.2258l-0.34879 0.34882h1.1062z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m28.83 165.62c0.14948-0.0299 0.35876-0.0498 0.63779-0.0498 0.30893 0 0.52817 0.0698 0.67766 0.18936 0.13952 0.10963 0.22921 0.28902 0.22921 0.50828s-0.06976 0.39865-0.19931 0.51824c-0.16941 0.16943-0.42852 0.23919-0.72748 0.23919h-0.19931v0.84714h-0.41855zm0.41855 1.0664 0.19931 0.0199c0.30893 0 0.50824-0.14949 0.50824-0.41858 0-0.24916-0.17938-0.38868-0.46838-0.38868-0.11959 0-0.19931 9e-3 -0.23917 0.0199v0.77737z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m31.112 167.23-0.19931 0.6478h-0.42852l0.73745-2.2823h0.52817l0.74742 2.2823h-0.44845l-0.20928-0.6478zm0.65772-0.31892-0.17938-0.55812c-0.03986-0.13952-0.07972-0.29898-0.11959-0.42854-0.0299 0.12956-0.06976 0.28902-0.10962 0.42854l-0.17938 0.55812z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m32.976 165.62c0.14948-0.0299 0.35876-0.0498 0.63779-0.0498 0.30893 0 0.52817 0.0698 0.67766 0.18936 0.13952 0.10963 0.22921 0.28902 0.22921 0.50828s-0.06976 0.39865-0.19931 0.51824c-0.16942 0.16943-0.42852 0.23919-0.72748 0.23919h-0.19931v0.84714h-0.41855zm0.41855 1.0664 0.19931 0.0199c0.30893 0 0.50824-0.14949 0.50824-0.41858 0-0.24916-0.17938-0.38868-0.46838-0.38868-0.11959 0-0.19931 9e-3 -0.23917 0.0199v0.77737z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m68.325 15.957c0 2.3421-1.8935 4.2357-4.2354 4.2357s-4.2354-1.8936-4.2354-4.2357c0-2.3421 1.8935-4.2357 4.2354-4.2357s4.2354 1.8936 4.2354 4.2357zm59.325 159.62h-127.12v-175.16h127.12z",
    fill: "none",
    stroke: "#5b5757",
    strokeMiterlimit: 10,
    strokeWidth: ".4983px"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#1d1d1b"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m18.626 153.75v14.102h-1.5447v-6.2289h-1.5845v6.2389h-1.5746v-14.102h4.7037zm-1.5945 1.5946h-1.5347v4.6742h1.5347z",
    strokeWidth: 0.99659
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    transform: "matrix(.99655 0 0 .99663 -.32888 .17024)",
    points: "12.7 166.7 12.7 168.28 9.57 168.28 9.57 154.1 12.72 154.1 12.72 155.67 11.17 155.67 11.17 160.39 12.7 160.39 12.7 161.97 11.16 161.97 11.16 166.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    transform: "matrix(.99655 0 0 .99663 -.32888 .17024)",
    points: "23.74 168.28 20.59 168.28 20.59 154.1 23.74 154.1 23.74 155.68 22.19 155.68 22.19 166.7 23.74 166.7"
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "scale(.99996 1)",
    x: 44.26849,
    y: 166.02264,
    fontFamily: "ZaraH1Sans-Regular, 'Zara H1 Sans'",
    fontSize: "5.9795px",
    strokeWidth: 0.99659
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 44.26849,
    y: 166.02264
  }, "zarahom"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 67.02063,
    y: 166.02264
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 69.9506,
    y: 166.02264
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-36",
    x: 71.256134,
    y: 166.02264
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 73.887131,
    y: 166.02264
  }, "om")), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: 0.99659
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m95.609 10.246c0.19931 0.03987 0.39862 0.07973 0.6079 0.1196 0.96666 0.20929 1.8038 0.64781 2.5113 1.3554l0.0299 0.0299c0.30893-0.29899 0.61786-0.60794 0.92679-0.9169l0.0299 0.01993c-0.01993 0.94679-0.0299 1.8836-0.04983 2.8304-0.93676-0.01993-1.8835-0.0299-2.8302-0.04983 0.32886-0.30895 0.64776-0.61791 0.98659-0.94679-0.13952-0.1196-0.23917-0.21926-0.34879-0.29899-0.75738-0.58801-1.6343-0.83716-2.591-0.81723-1.4849 0.01993-2.7704 0.58801-3.9364 1.465-0.51821 0.39865-0.98659 0.84713-1.3952 1.3654l-0.06976 0.07973c-0.3189-0.32888-0.62783-0.65777-0.95669-0.99662l0.09966-0.1196c0.97662-1.1262 2.1227-2.0232 3.5178-2.5813 0.67766-0.26909 1.3752-0.44848 2.0928-0.52821l0.22921-0.0299c0.37869 0 0.75738 0.01 1.1361 0.01993"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m86.72 17.681c0.01993-0.1196 0.03986-0.24916 0.06976-0.38868l0.07972 0.07973c0.36872 0.38868 0.74742 0.77737 1.1161 1.176l0.07972 0.16943c0.0299 0.16943 0.03986 0.34882 0.06976 0.54814l-0.10962-0.09966c-0.39862-0.41858-0.8072-0.83717-1.2058-1.2458l-0.08969-0.07973v-0.15946z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m100.13 16.046c-0.0199 0.1196-0.0498 0.23919-0.0698 0.37872l-0.07972-0.07973c-0.35872-0.36875-0.71748-0.7375-1.0762-1.1162l-0.07972-0.17939c-0.01993-0.14949-0.03986-0.30895-0.05979-0.48835l0.09966 0.09966c0.38866 0.40862 0.78728 0.81723 1.1759 1.2258l0.0897 0.06976z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m91.284 13.336c0.23917 0.12956 0.46838 0.24916 0.69759 0.36875l0.0299 0.0299c-0.24914 0.36875-0.49828 0.72754-0.74742 1.0963 0.09965 0.1196 0.18934 0.22922 0.29897 0.34882 0.20928-0.34882 0.41855-0.6777 0.62783-1.0365 0.2591 0.1196 0.50824 0.23919 0.77731 0.35879-0.43848 0.58801-0.87697 1.1661-1.3254 1.774 0.19931-0.01 0.37869-0.01993 0.56804-0.0299-0.0299-0.12956-0.05979-0.24916-0.08969-0.37872 0.21924-0.0598 0.41855-0.10963 0.6378-0.17939 0.13952 0.36875 0.27903 0.72754 0.41855 1.0863h0.01993c0.01993-0.99663 0.0299-1.9933 0.04983-2.9899 0.27903-0.01 0.53814-0.0299 0.79724-0.0299 0.73745-0.0299 1.4649-0.12956 2.1825-0.26909l0.10962 0.03987c0.10962 0.31892 0.22921 0.63784 0.33883 0.97669-0.10962 0.01993-0.20928 0.04983-0.30893 0.06976-0.18934 0.0299-0.37869 0.03987-0.56804 0.06976l-0.09966 0.07973c-0.01993 0.35879-0.03986 0.71757-0.05979 1.0764v0.03987c0.34879 0 0.68762-0.01 1.0364-0.0299 0 0.32889-0.01 0.64781-0.01993 0.99662-0.32886 0-0.66769-0.01-1.0364-0.01993 0.0299 0.32889 0.04983 0.62787 0.08969 0.9169 0.0299 0.23919 0.08969 0.47838 0.13952 0.71757l0.11959 0.18936 0.15945-0.15946c0.06976-0.12956 0.11959-0.26909 0.18934-0.40862l0.03986 0.0897c0.10962 0.26909 0.21924 0.53818 0.33883 0.80727l0.0299 0.25912c-0.05979 0.24916-0.13952 0.47838-0.27904 0.68767-0.27904 0.40862-0.71752 0.44848-1.0563 0.07973-0.24914-0.26909-0.37869-0.60794-0.42852-0.96673-0.08969-0.68767-0.14948-1.3753-0.21924-2.063l-0.01993-0.18936c-0.19931 0-0.38866 0-0.578-0.01-0.01 0.68767-0.01993 1.3654-0.0299 2.053 0.21924-0.03986 0.41855-0.07973 0.63779-0.1196 0 0.34882 0.01 0.68767 0.01993 1.0365-0.69759 0.12956-1.3952 0.25912-2.1027 0.38868 0-0.31892 0.01-0.63784 0.01993-0.95676-0.11959 0.01993-0.21924 0.0299-0.3189 0.03986-0.05979-0.53818-0.11959-1.0764-0.17938-1.6245 0.18934-0.0299 0.36872-0.04983 0.56804-0.06976 0.07972 0.47838 0.16941 0.9468 0.24914 1.4252h0.14948c0-0.56808 0.01993-1.1262 0.0299-1.7042-0.22921 0.04983-0.45841 0.09966-0.68762 0.13953l-0.07972-0.22922c-0.11959 0.01-0.23917 0.0299-0.38866 0.03987-0.01993 0.98666-0.0299 1.9634-0.04983 2.96-0.30893 0-0.6079 0-0.90686-0.01 0.01-0.95676 0.0299-1.9135 0.03986-2.8802-0.33883 0.01-0.67766 0.0299-1.0364 0.03986 0-0.31892 0.01-0.62787 0.01993-0.96673h0.37869l0.14948-0.06976c0.09965-0.0897 0.18934-0.19932 0.27904-0.29899-0.29897-0.31892-0.578-0.63784-0.87697-0.95676 0.15945-0.26909 0.32886-0.52821 0.49828-0.80727l0.19931 0.10963c0.18934-0.31892 0.36872-0.62788 0.55807-0.95676m2.88 1.3953c0 0.37872-0.01 0.74747-0.01993 1.1162 0.18935-0.01 0.35876-0.01993 0.5481-0.01993 0-0.36875 0.01-0.71757 0.01993-1.0863h-0.53814"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m97.393 19.276c0.30893 0.33885 0.59793 0.65777 0.91683 0.99662-0.18934 0.20929-0.39862 0.44848-0.61786 0.66774-0.99655 1.0066-2.1526 1.7541-3.4979 2.2025-0.61786 0.20929-1.2557 0.32889-1.9034 0.36875-1.0464 0.0598-2.033-0.1196-2.9697-0.59798-0.41855-0.21926-0.80721-0.49831-1.146-0.8272l-0.09965-0.0897c-0.30893 0.29899-0.6079 0.58801-0.9268 0.89696 0.01993-0.95676 0.0299-1.8936 0.04983-2.8404 0.94672 0.01993 1.8835 0.0299 2.8202 0.03987-0.3189 0.31892-0.64776 0.62787-0.97662 0.94679 0.2591 0.26909 0.51821 0.47838 0.81717 0.63784 0.74742 0.41858 1.5546 0.56808 2.3917 0.49831 1.8536-0.14949 3.3584-1.0066 4.634-2.3221 0.16941-0.17939 0.3189-0.36875 0.49828-0.56808"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m90.646 19.694c-0.22921-0.13953-0.43848-0.26909-0.64776-0.39865l-0.03986-0.0897c0.14948-0.52821 0.16941-1.0863 0.23917-1.6345l0.10962-0.07973c0.18934 0.01993 0.37869 0.0299 0.578 0.04983 0 0.72754-0.03986 1.4351-0.24914 2.1627"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m88.833 15.478c-0.32886-0.32889-0.65772-0.65777-0.99655-0.99663 0.16941-0.25912 0.33883-0.50828 0.51821-0.7674 0.3189 0.33885 0.62783 0.66774 0.94673 1.0066-0.15945 0.25912-0.3189 0.50828-0.46838 0.74747"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m98.031 18.309c0.32886 0.31892 0.64776 0.64781 0.96666 0.96673-0.16941 0.24916-0.33883 0.48835-0.50824 0.71757-0.30893-0.30895-0.61786-0.61791-0.92679-0.93683 0.15945-0.24916 0.30893-0.49831 0.46838-0.74747"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m88.364 16.525c-0.19931-0.19932-0.38866-0.38868-0.578-0.57804-0.13952-0.13953-0.26907-0.27906-0.39862-0.41858l-0.0299-0.09966c0.09966-0.20929 0.19931-0.40862 0.29897-0.62788l0.07972 0.06976c0.289 0.29899 0.56804 0.59798 0.85704 0.887l0.0299 0.14949c-0.08969 0.19932-0.16941 0.40862-0.2591 0.60794"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m99.177 18.957c-0.18934-0.18936-0.37869-0.37872-0.56804-0.56808-0.11959-0.1196-0.23917-0.23919-0.34879-0.36875l-0.03986-0.1196c0.08969-0.21926 0.17938-0.43852 0.27904-0.66774l0.09965 0.10963c0.26907 0.30895 0.5481 0.61791 0.82714 0.9169l0.01993 0.16943c-0.08969 0.17939-0.17938 0.35878-0.26907 0.53818"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m88.085 17.711c-0.37869-0.38868-0.74742-0.75744-1.1062-1.1262l-0.01993-0.0897c0.04983-0.15946 0.09965-0.31892 0.14948-0.46841l0.03986-0.0299 0.08969 0.13953c0.29897 0.29899 0.59793 0.60794 0.88693 0.90693l0.04983 0.16943c-0.03986 0.15946-0.05979 0.32889-0.08969 0.48835"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m98.798 16.066 0.07972 0.07973c0.3189 0.32889 0.63779 0.66774 0.95669 1.0066l0.0299 0.15946c-0.05979 0.14949-0.09966 0.29899-0.15945 0.45845l-0.08969-0.0897c-0.289-0.31892-0.578-0.63784-0.87697-0.95676l-0.04983-0.17939c0.0299-0.14949 0.05979-0.30895 0.09965-0.47838"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.99659
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m2.9199 5.6816h17.559c5.0326 0 9.1185 4.136 9.1185 9.2288v52.921h-17.559c-5.0326 0-9.1185-4.136-9.1185-9.2288z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m16.124 65.708h11.361v-31.733c0-3.9167-3.1391-7.1059-7.0058-7.1059h-11.361v31.733c0 3.9167 3.1391 7.1059 7.0058 7.1059",
    fill: "#1e1e1c"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m16.124 65.011c-3.468 0-6.2982-2.8703-6.2982-6.3983v-31.035h10.653c3.468 0 6.2982 2.8703 6.2982 6.4083v31.025z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m9.1184 58.602c0 3.9167 3.1391 7.1059 7.0058 7.1059h11.361v-22.603l-9.1783 4.5247-9.1783-4.5247v15.488z",
    fill: "#1e1e1c"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m16.124 65.011c-3.468 0-6.2982-2.8703-6.2982-6.3983v-14.351l8.4707 4.1759 8.4707-4.1759v20.76h-10.653z",
    fill: "#1e1e1c"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    strokeWidth: 0.99659
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m22.373 60.685h-0.55807c0.20928-2.3321 0.53814-5.9399 0.68762-7.5744 0.01993-0.16943-0.10962-0.30895-0.26907-0.32889-0.16941-0.01993-0.3189 0.10963-0.32886 0.26909-0.23917 2.5115-0.87697 9.6772-0.88693 9.757-0.01 0.1196-0.12955 0.21926-0.26907 0.21926h-4.8931c-0.13952 0-0.2591-0.09966-0.26907-0.21926 0-0.06976-0.64776-7.2455-0.88693-9.757-0.01993-0.16943-0.15945-0.28902-0.32886-0.26909-0.16941 0.01993-0.289 0.15946-0.26907 0.32889 0.15945 1.6345 0.47835 5.2423 0.69759 7.5843h-0.10962s-0.44845-0.0093-0.44845-0.0093c-0.289 0-0.52817 0.23919-0.52817 0.52821v1.8936c0 0.28902 0.23917 0.52821 0.52817 0.52821h0.44845c0.21924 0 0.40859-0.12956 0.48831-0.31892 0.15945 0.19932 0.40859 0.31892 0.68762 0.31892h4.8931c0.27903 0 0.52817-0.12956 0.68762-0.31892 0.07972 0.18936 0.26907 0.32889 0.48831 0.32889h0.44845c0.289 0 0.52817-0.23919 0.52817-0.52821v-1.8936c0-0.28902-0.23917-0.52821-0.52817-0.52821"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m22.682 51.696h-8.7597v-0.7674h0.64776l0.19931-0.06976 0.79724-0.69764s0.11959-0.0598 0.22921-0.0598h5.0326c0.10962 0 0.19931 0.0299 0.22921 0.0598l0.79724 0.69764 0.19931 0.06976h0.63779v0.03986 0.72754zm-0.01-1.3554h-0.52817l-0.70755-0.61791c-0.14948-0.12956-0.37869-0.20929-0.61786-0.20929h-5.0326c-0.23917 0-0.46838 0.07973-0.61786 0.20929l-0.70755 0.61791h-0.52817c-0.32886 0-0.59793 0.27906-0.59793 0.62787v0.7973c0 0.10963 0.0299 0.21926 0.07972 0.31892l0.09966 0.09966c0.09966 0.06976 0.20928 0.09966 0.3189 0.09966h8.949c0.10962 0 0.22921-0.0299 0.3189-0.09966l0.09965-0.09966c0.04983-0.09966 0.07972-0.20929 0.07972-0.31892v-0.7973c0-0.34882-0.26907-0.62787-0.59793-0.62787"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m20.818 50.37h-5.0326c-0.13952 0-0.24914 0.10963-0.24914 0.24916s0.10962 0.24916 0.24914 0.24916h5.0326c0.13952 0 0.24914-0.10963 0.24914-0.24916s-0.10962-0.24916-0.24914-0.24916"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m20.768 56.121c-0.05979-0.14949-0.23917-0.21926-0.38866-0.15946-0.14948 0.0598-0.22921 0.23919-0.15945 0.38868 0.09965 0.24916 0.15945 0.51824 0.15945 0.7973 0 1.1362-0.92679 2.073-2.0728 2.073s-2.0728-0.92686-2.0728-2.073c0-1.1461 0.9268-2.073 2.0728-2.073h0.01993s-0.42852 0.42855-0.42852 0.42855c-0.11959 0.1196-0.11959 0.30895 0 0.41858l0.20928 0.0897 0.20928-0.0897 0.93676-0.93683c0.11959-0.1196 0.11959-0.30895 0-0.42855l-0.93676-0.93683c-0.11959-0.1196-0.30893-0.1196-0.41855 0-0.11959 0.1196-0.11959 0.30895 0 0.41858l0.42852 0.42855h-0.0299c-1.4749 0-2.6708 1.196-2.6708 2.671s1.1959 2.671 2.6708 2.671 2.6708-1.196 2.6708-2.671c0-0.34882-0.06976-0.69764-0.19931-1.0265"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "#010101",
    strokeWidth: 0.99659
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m19.313 16.804c-0.75738 1.1162-0.10962 2.5813 0.66769 3.3287 0.71752 0.6777 1.2856 0.83717 1.3653 0.8571l0.36872-0.69764 1.0563 2.8703-2.9697 0.60794 0.39862-0.72754-0.39862-0.22922c-1.2557-0.81723-1.5148-1.9235-1.6045-2.2723-0.14948-0.59798-0.36872-2.372 1.1361-3.7373"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m19.293 16.854c0.53814 1.2358 2.1227 1.475 3.169 1.2059 0.92679-0.23919 1.3653-0.61791 1.445-0.68767 0 0-0.39862-0.69764-0.39862-0.69764l2.9897 0.65777-1.0862 2.8304-0.39862-0.71757-0.38866 0.20929c-1.3553 0.62788-2.4316 0.25912-2.7704 0.13953-0.58797-0.18936-2.2123-0.95676-2.5611-2.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m24.585 13.864c-0.20928 1.475-1.0962 2.1926-1.3752 2.4118-0.47834 0.38868-1.9931 1.3454-3.8666 0.55811 1.3354 0.20929 2.3917-0.98666 2.7306-2.0132 0.30893-0.9169 0.21924-1.5049 0.19931-1.5946l-0.79724-0.03986 2.1625-2.1726 1.8038 2.4417-0.81717-0.04983-0.0299 0.44848z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m15.516 12.618c-0.67766 0-1.2357-0.54814-1.2357-1.2358s0.55807-1.2358 1.2357-1.2358 1.2357 0.55811 1.2357 1.2358c0 0.67771-0.55807 1.2358-1.2357 1.2358"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m13.603 18.618c0.10962-0.28902 0.2591-0.26909 0.2591-0.26909s0.13952-0.0299 0.21924 0.25912l1.156 4.0563c-0.96666-0.27906-1.8436-0.75744-2.591-1.3853l0.94673-2.651zm3.5976-10.823c-4.4546 0-8.082 3.6277-8.082 8.0926 0 4.4649 3.6275 8.0826 8.082 8.0826 0.23917 0 0.46838-0.01 0.70755-0.03986l0.04983 0.81723 1.4749-1.4351-1.6543-1.2657 0.05979 0.8571c-0.20928 0.01993-0.42852 0.0299-0.64776 0.0299-0.33883 0-0.67766-0.0299-1.0065-0.06976l-0.0299-0.21926-0.76735-6.5478c-0.10962-1.2358 0.59793-1.4351 1.0364-1.2458l2.4515 0.98666c0.27904 0.1196 0.41855-0.1196 0.41855-0.1196s0.15945-0.24916-0.11959-0.42855c0 0-3.3385-2.2125-4.056-2.352-0.97662-0.17939-1.9333 0.60794-2.1426 1.6345l-1.1859 5.8103c-1.0165-1.2258-1.6343-2.8005-1.6343-4.5147 0-3.8868 3.169-7.0561 7.0556-7.0561 2.0728 0 3.9464 0.90693 5.2419 2.3421l0.72749-0.73751c-1.4749-1.6145-3.6075-2.6311-5.9694-2.6311"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    transform: "matrix(.99655 0 0 .99663 -.32888 .17024)",
    points: "8.8 39.66 8.8 38.8 9.31 38.8 9.31 40.25 6.31 40.25 6.31 38.81 6.81 38.81 6.81 39.66 7.52 39.66 7.52 38.98 8.02 38.98 8.02 39.66",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m8.1319 38.66-0.019931-0.55811c0.17938-0.01993 0.39862-0.0598 0.39862-0.26909 0-0.16943-0.13952-0.21926-0.27903-0.21926-0.15945 0-0.289 0.10963-0.44845 0.27906l-0.27903 0.28902c-0.24914 0.26909-0.49828 0.42855-0.82714 0.42855-0.41855 0-0.77731-0.25912-0.77731-0.7973 0-0.37872 0.18935-0.72754 0.84707-0.74747l0.019931 0.51825c-0.21924 0.01993-0.38866 0.06976-0.38866 0.25912 0 0.14949 0.10962 0.20929 0.24914 0.20929 0.15945 0 0.30893-0.15946 0.44845-0.30895l0.2591-0.26909c0.27903-0.28902 0.53814-0.44848 0.867-0.44848 0.43848 0 0.78728 0.29899 0.78728 0.7973s-0.32886 0.78733-0.867 0.81723",
    fill: "#fff",
    strokeWidth: 0.99659
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m24.605 38.979-5.7601-6.5578c-0.23917-0.26909-0.70755-0.50828-1.0763-0.54814l-2.89-0.28902h-0.13952l-0.88693-1.8537c-0.06976-0.13953-0.24914-0.19932-0.38866-0.13953l-0.15945 0.15946v0.20929l0.81717 1.6943h-0.0299l-1.156-1.3056c-0.09966-0.10963-0.289-0.12956-0.41855-0.03986-0.11959 0.09966-0.13952 0.26909-0.03986 0.38868l1.1959 1.3654c-0.07972 0.17939-0.12955 0.38868-0.13952 0.56808l-0.18934 2.6909c-0.01993 0.34882 0.13952 0.8272 0.37869 1.0963l5.7601 6.5578c0.15945 0.17939 0.39862 0.28902 0.64776 0.28902 0.19931 0 0.38866-0.0598 0.53814-0.17939l3.8168-2.9899c0.16941-0.12956 0.27903-0.31892 0.29896-0.53818 0.01993-0.20929-0.04983-0.41858-0.18934-0.57804m-10.454-6.3884 0.67766 0.77737c-0.11959 0.16943-0.19931 0.36875-0.21924 0.58801-0.03986 0.34882 0.07972 0.68767 0.30893 0.95676 0.2591 0.29899 0.65772 0.46841 1.0663 0.46841 0.3189 0 0.63779-0.10963 0.88693-0.29899 0.58797-0.45845 0.66769-1.2856 0.17938-1.8438-0.2591-0.29899-0.64776-0.46841-1.0663-0.46841-0.2591 0-0.51821 0.07973-0.73745 0.20929l-0.68762-0.77737h0.01l0.11959-0.01993 0.04983-0.0299h0.06976s2.89 0.29899 2.89 0.29899c0.21924 0.01993 0.5481 0.18936 0.68762 0.34882l5.7601 6.5578c0.08969 0.09966 0.06976 0.23919-0.0299 0.32889l-3.8168 2.9899-0.15945 0.04983-0.18934-0.07973-5.7601-6.5578c-0.13952-0.15946-0.2591-0.49831-0.23917-0.7076l0.18934-2.6909v-0.07973zm1.1261 1.2757 0.22921 0.09966 0.18934-0.0598c0.11959-0.09966 0.13952-0.27906 0.03986-0.38868l-0.09966-0.10963c0.10962-0.04983 0.22921-0.07973 0.35876-0.07973 0.23917 0 0.45841 0.09966 0.61786 0.26909 0.27904 0.31892 0.22921 0.7973-0.10962 1.0564-0.13952 0.10963-0.3189 0.16943-0.50824 0.16943-0.23917 0-0.45842-0.09966-0.61786-0.26909-0.17938-0.20929-0.21924-0.47838-0.13952-0.71757l0.0299 0.03986z",
    fill: "#1d1d1c",
    strokeWidth: 0.99659
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    fill: "#010202",
    strokeWidth: 0.99659
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m6.2982 37.285v0.23919h0.96666v-0.24916c0-0.18936-0.12955-0.29899-0.49828-0.29899-0.3189 0-0.48831 0.09966-0.48831 0.30895h0.00997z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m5.0326 36.138v4.2058c0 0.77737 0.63779 1.3953 1.3952 1.3953h3.3484v-7.0063h-3.3484c-0.77731 0-1.3952 0.63784-1.3952 1.4052m1.2656 2.3819v0.94679h0.80721v-0.75744h0.56804v0.75744h1.4151v0.65777h-3.3484v-1.6046h0.56804zm2.7903-1.5547-1.3254 0.34882v0.21926h1.3254v0.66774h-3.3484v-0.95676c0-0.56808 0.30893-0.90693 0.99655-0.90693 0.48831 0 0.75738 0.15946 0.87697 0.38868l1.4749-0.43852v0.68767z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m5.0326 28.265v4.2058c0 0.7674 0.62783 1.4052 1.4051 1.4052h3.3484v-7.0063h-3.3484c-0.76735 0-1.4051 0.62787-1.4051 1.4052zm4.046 2.362v1.9135h-3.3484v-1.8737h0.5481v1.196h0.78728v-1.1262h0.5481v1.1262h0.8969v-1.2458h0.56804zm0.059793-1.2657c0 0.34882-0.079724 0.61791-0.22921 0.7973-0.14948 0.17939-0.40859 0.26909-0.77731 0.26909h-0.099655v-0.67771h0.08969c0.17938 0 0.30893-0.0299 0.39862-0.09966 0.079724-0.06976 0.12955-0.17939 0.12955-0.34882 0-0.1196-0.039862-0.21926-0.10962-0.28902-0.069759-0.07973-0.16941-0.10963-0.30893-0.10963-0.099655 0-0.18935 0.01993-0.2591 0.04983-0.069759 0.03986-0.12955 0.10963-0.17938 0.22922-0.15945 0.39865-0.26907 0.64781-0.3189 0.7375-0.049828 0.09966-0.11959 0.17939-0.18935 0.23919-0.069759 0.0598-0.15945 0.1196-0.26907 0.15946-0.099655 0.03986-0.21924 0.0598-0.36872 0.0598-0.3189 0-0.55807-0.0897-0.72748-0.26909-0.16941-0.17939-0.24914-0.43852-0.24914-0.7674 0-0.32889 0.079724-0.58801 0.22921-0.7674 0.14948-0.17939 0.37869-0.26909 0.68762-0.26909h0.079724v0.64781c-0.32886 0-0.49828 0.1196-0.49828 0.36875 0 0.24916 0.12955 0.38868 0.38866 0.38868 0.11959 0 0.21924-0.0299 0.27903-0.07973 0.059793-0.04983 0.11959-0.13953 0.17938-0.26909l0.22921-0.51824c0.08969-0.22922 0.20928-0.38868 0.34879-0.48835 0.13952-0.09966 0.3189-0.14949 0.53814-0.14949 0.68762 0 1.0264 0.38868 1.0264 1.1661h-0.019931z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLittleBasket);
export default __webpack_public_path__ + "static/media/LittleBasket.053ed4157ddc6bb50c5b3ae78ac470c3.svg";
export { ForwardRef as ReactComponent };